import {createRouter, createWebHashHistory} from 'vue-router';

import Map from '@/views/Map';
import Dashboard from '@/views/Dashboard';
import Library from '@/views/Library';
import Path from '@/views/Path';
import Content from '@/views/Content';
import Access from '@/views/login/Access';
import {redirectToLogin, setReturnPath, getReturnPath, clearReturnPath} from "@/Helper";
import {getToken} from "@/Helper";

const router = createRouter({
    mode: 'history',
    history: createWebHashHistory(process.env.BASE_PATH + '/'),
    base: '/',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {top: 0, behavior: 'smooth',}
        }
    },
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                title: "Loading...",
                requiresAuth: true,
                setReturnPath: true,
            }
        },
        {
            path: '/dl/:dl',
            name: 'dashboardDl',
            component: Dashboard,
            meta: {
                title: "Loading...",
                requiresAuth: true,
                setReturnPath: true,
            }
        },
        {
            path: '/quest',
            name: 'quest',
            redirect: '/',
        },
        {
            path: '/quest/dl/:dl',
            name: 'questDl',
            redirect: to => ({ name: 'dashboardDl', params: { dl: to.params.dl } }),
        },
        {
            path: '/library',
            name: 'library',
            component: Library,
            meta: {
                title: "Loading...",
                requiresAuth: true,
                setReturnPath: true,
            }
        },
        {
            path: '/path/:id',
            name: 'path',
            component: Path,
            meta: {
                title: "Loading...",
                requiresAuth: true,
                setReturnPath: true,
            }
        },
        {
            path: '/path/:id/dl/:dl',
            name: 'pathDl',
            component: Path,
            meta: {
                title: "Loading...",
                requiresAuth: true,
                setReturnPath: true,
            },
            props: true
        },
        {
            path: '/content/:id/mission/:mission',
            name: 'content',
            component: Content,
            meta: {
                title: "Loading...",
                requiresAuth: true,
            }
        },
        {
            path: '/content/:id/mission/:mission/dl/:dl',
            name: 'contentDl',
            component: Content,
            meta: {
                title: "Loading...",
                requiresAuth: true,
            },
            props: true
        },
        {
            path: '/access',
            component: Access,
            meta: {
                title: "Processing...."
            }
        },
        {
            path: '/map',
            component: Map,
            name: 'map',
            meta: {
                title: "Map"
            },
            beforeEnter: (to, from, next) => {
                //getTerminology(to.query.t).then(r => console.log(r))
                next()
            }
        }
    ],
});

// Global navigation guard
router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title;

    //check if user has access token
    const token = getToken();

    //check if this route requires auth
    const requiresAuth = to.meta.requiresAuth ?? false;

    //get dashboard link
    const dashboardLink = to.params.dl ?? '';
    const extraParams = dashboardLink === '' ? {} : {dl: dashboardLink};

    if (requiresAuth && token === null) {
        redirectToLogin(window.location.href, extraParams);

        next();
    } else {
        if (window.location.href === getReturnPath()) {
            clearReturnPath();
        } else if (from.meta.setReturnPath) {
            setReturnPath(window.location.href);
        }

        next();
    }
});

export default router;